import React from 'react';
export const Footer = () => {
  return <footer className="bg-gray-100 py-4 mt-8 border-t border-gray-200" data-id="element-108">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center text-sm text-gray-600" data-id="element-109">
        <div className="flex justify-center space-x-6 mb-2" data-id="element-110">
          <a href="#" className="hover:text-blue-900 hover:underline" data-id="element-111">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-blue-900 hover:underline" data-id="element-112">
            Terms of Service
          </a>
          <a href="#" className="hover:text-blue-900 hover:underline" data-id="element-113">
            Contact Us
          </a>
        </div>
        <p data-id="element-114">
          © {new Date().getFullYear()} Active Life Journal. All rights
          reserved.
        </p>
      </div>
    </footer>;
};